import { useEffect, useState } from 'react';
import Proptypes from 'prop-types';
import { createPortal } from 'react-dom';

const CustomMapControl = ({ map, maps, position, children }) => {
  const [controlDiv] = useState(document.createElement('div'));

  useEffect(() => {
    if (map && maps) {
      map.controls[position || maps.ControlPosition.LEFT_TOP].push(controlDiv);
    }
  }, [map, maps, position, controlDiv]);

  return createPortal(children, controlDiv);
};

export default CustomMapControl;

CustomMapControl.propTypes = {
  map: Proptypes.object,
  maps: Proptypes.object,
  position: Proptypes.string,
  children: Proptypes.node,
};
